export default class UserStatus {}

// UserStatus.Active = 'ACTIVE';
// UserStatus.Locked = 'LOCKED';
// UserStatus.Inactive = 'INACTIVE';
UserStatus.Onboarding = 'ONBOARDING';
